import dynamic from "next/dynamic";
import type { SideBarHeadingProps } from "./SideBarHeading.d";

const SideBarHeading = dynamic(() => import("./SideBarHeading"));

export { SideBarHeading };
export type { SideBarHeadingProps };
